import type { CreateOrganisationRequest, OrganisationDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function createOrganisationDetails(formData: CreateOrganisationRequest): Promise<OrganisationDetailed> {
  return requestApiJsonOrThrow<OrganisationDetailed>('admin/organisations', {
    method: 'POST',
    body: formData,
  })
}
